import { createSelector } from 'reselect';

const modalState = (state) => state.modal;

const getModalData = createSelector(modalState, (modal) => modal.data);

export {
    getModalData,
};
